import React from 'react'

import Cake from '../Icons/Cake'

export const Birthday = ({ as: Tag = "p", username}) => (
  <Tag><span><Cake/></span> It's {username || 'the user'}'s birthday</Tag>
)

export default Birthday
